import { Link } from "react-router-dom";

export default function Button({ text, href, active }) {
  return (
    <Link
      to={href}
      className={`group w-full min-w-fit p-2 flex justify-center items-center text-sm rounded-lg
    ${
      active === true
        ? "bg-zi-inputbg-dark drop-shadow-md"
        : "bg-zi-bg1-light dark:bg-transparent"
    }`}
    >
      <span
        className={`text-nowrap
      ${
        active === true
          ? "text-zi-text-dark drop-shadow-md"
          : "text-zi-text-light dark:text-zi-text-dark/50 group-hocus:dark:text-zi-text-dark/75"
      }`}
      >
        {text}
      </span>
    </Link>
  );
}
